import React, { useState, useEffect, Fragment } from "react";
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import api from "../../services/api";
import { useNavigate } from "react-router-dom";
import { roles } from "../../utils/constants";
import { ScrollContainer } from "react-indiana-drag-scroll";
import { useSelector } from "react-redux";
import { saveAs } from "file-saver";
import { Toast } from "../../shared/Toast";
import {
  SlDrawer,
  SlButton,
  SlIcon,
} from "@shoelace-style/shoelace/dist/react";
import PreviewFrameEdit from "../PreviewFrameEdit";
import Paginator from "../../shared/Paginator";
import config from "../../config";

export const NetworkAdContext = React.createContext();
function Queued() {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
  // const [showapprove, setShowApprove] = useState(false);
  const [campPreview, setCampPreview] = useState({
    hdl: "",
    bdy: "",
    img: "",
    adt_cls: "",
    adv: "",
    count: 0,
  });
  const [clickindex, setClickIndex] = useState(-1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigate = useNavigate();
  const Networkdate = useSelector((state) => state.Head.network_ads_date);
  const NetworkAdType = useSelector((state) => state.Head.network_ad_type);
  const NetworkAdSearch = useSelector((state) => state.Head.network_ad_search)

  const fetchData = async (page) => {
    try {
      setLoader(true);
      const res = await api({
        url: `/networkads/queued`,
        method: "POST",
        responseType: "json",
        data: {
          date: Networkdate,
          type: NetworkAdType,
          search:NetworkAdSearch,
          limit: config.PER_PAGE,
          offset: (page - 1) * config.PER_PAGE,
        },
      });
      if (res.code === 200) {
        setData(res?.data?.result);
        setTotalRecords(res?.data?.totalRecords);
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      if (error?.response?.status === 401) navigate("/");
    }
  };

  const loadMoreData = async (offset) => {
    try {
      setLoader(true);
      let res = await api({
        url: `/networkads/queued`,
        method: "POST",
        responseType: "json",
        data: {
          date: Networkdate,
          type: NetworkAdType,
          search:NetworkAdSearch,
          limit: config.PER_PAGE,
          offset: offset,
        },
      });
      if (res.code === 200) {
        setData((prevData) => [...prevData, ...res.data.result]);
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      if (error?.response?.status === 401) navigate("/");
    }
  };
  const loadPrevData = async (offset) => {
    try {
      setLoader(true);
      let res = await api({
        url: `/networkads/queued`,
        method: "POST",
        responseType: "json",
        data: {
          date: Networkdate,
          type: NetworkAdType,
          search:NetworkAdSearch,
          limit: config.PER_PAGE,
          offset: offset,
        },
      });
      if (res.code === 200) {
        setClickIndex(res.data.result.length);
        setData((prevData) => [...res.data.result, ...prevData]);
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      if (error?.response?.status === 401) navigate("/");
    }
  };
  // const yeseterdayQueued = async () => {
  //   try {
  //     const res = await api({
  //       url: `/networkads/queuedCount`,
  //       method: "POST",
  //       responseType: "json",
  //       data: {
  //         date: getYesterdayDateUpdate(),
  //       },
  //     });
  //     if (res?.code === 200) {
  //       if (res?.data > 0 && Networkdate === todayDate()) {
  //         setShowApprove(true)
  //       }
  //     }
  //   } catch (error) {}
  // };
  // const handleApproveYesterday = async () => {
  //   try {
  //     const res = await api({
  //       url: `/networkads/approvequeued`,
  //       method: "POST",
  //       responseType: "json",
  //       data: {
  //         date: getYesterdayDateUpdate(),
  //       },
  //     });
  //     if (res.code === 200) {
  //       setShowApprove(false);
  //       Toast("success", "Approved Successfully");
  //     } else {
  //       Toast("error", res.data.message);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  const handleShowPreview = () => {
    setShow(true);
  };
  const handleNextClick = () => {
    if (clickindex === data.length - 2) {
      if (currentPage < Math.ceil(totalRecords / config.PER_PAGE)) {
        if (currentPage !== 1)
          loadMoreData((currentPage - 1) * config.PER_PAGE + data.length);
        else {
          loadMoreData(data.length);
        }
      }
    }
  };
  const handlePrevClick = () => {
    if (currentPage > 1) {
      loadPrevData((currentPage - 2) * config.PER_PAGE);
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };
  const handleClickhdl = async () => {
    if (campPreview?.adv) {
      await navigator.clipboard.writeText(campPreview.adv);
      Toast("success", "Advertiser Copied");
    }
  };

  const handleClose = () => {
    setShow(false);
    setCurrentPage(1);
    fetchData(1);
  };

  const removeFromData = async (index, operation) => {
    const id = data[index]["_id"];
    try {
      const res = await api({
        url: `/networkads/update`,
        method: "POST",
        responseType: "json",
        data: {
          id: id,
          status: operation === "approve" ? 1 : 2,
        },
      });
      if (res.code === 200) {
        const newData = data.filter((_, i) => i !== index);
        setData(newData);
        if (index === data.length - 1) {
          setClickIndex((prevIndex) => Math.max(0, prevIndex - 1));
        } else {
          setClickIndex(index);
        }
        Toast(
          "success",
          `${operation === "approve" ? "Approve" : "Blocked"} Successfully`
        );
        handleNextClick();
      } else {
        Toast("error", res.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  function getYesterdayDate() {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const year = yesterday.getFullYear();
    const month = String(yesterday.getMonth() + 1).padStart(2, "0");
    const day = String(yesterday.getDate()).padStart(2, "0");

    return `${day}-${month}-${year}`;
  }

  function todayDate() {
    let today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  function getYesterdayDateUpdate() {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const year = yesterday.getFullYear();
    const month = String(yesterday.getMonth() + 1).padStart(2, "0");
    const day = String(yesterday.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  const handleBlockImageDownload = (url, filename) => {
    saveAs(url, `${filename}.jpg`);
  };

  const handlePageClick = (event) => {
    const selectedPage = event.selected + 1;
    setCurrentPage(selectedPage);
    fetchData(selectedPage);
  };
  const handleCheckboxChange = (_id) => {
    setSelectedRows((prevSelectedRows) => {
      if (prevSelectedRows.includes(_id)) {
        return prevSelectedRows.filter((rowIndex) => rowIndex !== _id);
      } else {
        return [...prevSelectedRows, _id];
      }
    });
  };

  // const handleDismiss = () =>{
  //   localStorage.setItem('show', false); 
  //   setShowApprove(false)
  // }

  const handleCheckAll = () => {
    if (selectedRows.length === data.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(data.map((item, index) => item._id));
    }
  };
  useEffect(() => {
    const role = localStorage.getItem("role");
    if (role !== roles.network_ad_manager) navigate("/pagenotfound");
    // yeseterdayQueued();
    fetchData(1);
    setCurrentPage(1);
  }, [Networkdate, NetworkAdType, NetworkAdSearch]);

  useEffect(() => {
    setCampPreview(data[clickindex]);
  }, [clickindex, data]);

  const handleApproveMulti = async () => {
    try {
      let res = await api({
        url: "/networkads/approvemulti",
        method: "POST",
        responseType: "json",
        data: {
          selectedRows,
        },
      });
      if (res.code === 200) {
        Toast("success", "Approved All Ads Successfully");
        setSelectedRows([]);
        fetchData(1);
      } else {
        Toast("error", res.message);
      }
    } catch (error) {}
  };
  return (
    <>
      {/* { showapprove === true && localStorage.getItem('show') === "true" ? <div className="flex justify-end mb-3">
      <div style={{backgroundColor:'#fbfaff'}} className="w-96 h-18 rounded align-center">
        <p className="font-medium m-2">{`Approve everything in queue yesterday (${getYesterdayDate()}) ?`}</p>
        <div className="flex gap-3 justify-end mr-2 mb-2">
          <SlButton onClick={handleApproveYesterday} size="small" variant="default">
            Approve
          </SlButton>
          <SlButton onClick={handleDismiss} size="small" variant="default">
           Dismiss
          </SlButton>
        </div>
    </div>
      </div> : null} */}
      
      <SlDrawer
        label="Queued Network Ads"
        open={show}
        onSlAfterHide={handleClose}
        style={{ "--size": "100vw" }}
      >
        <div className="flex flex-row">
          <div className="w-3/12"></div>
          <div className="w-1/12 mb-auto" style={{ marginTop: "272px" }}>
            <SlButton
              disabled={clickindex === 0 || data.length === 0 ? true : false}
              onClick={() => {
                setClickIndex((prevIndex) => prevIndex - 1);
                if (clickindex === 1) {
                  handlePrevClick();
                }
              }}
              variant="neutral"
            >
              Prev
            </SlButton>
          </div>
          <div className="w-4/12">
            <NetworkAdContext.Provider value={{ campPreview }}>
              <PreviewFrameEdit showPreview={show} />
            </NetworkAdContext.Provider>
          </div>
          <div className="w-1/12 my-auto ">
            <SlButton
              disabled={
                clickindex === data.length - 1 || data.length === 0
                  ? true
                  : false
              }
              onClick={() => {
                setClickIndex((prevIndex) => prevIndex + 1);
                handleNextClick();
              }}
              variant="neutral"
            >
              Next
            </SlButton>
            <div className="flex flex-col w-auto py-3">
              <SlButton
                className="w-16 py-1"
                title="Approve"
                disabled={data.length > 0 ? false : true}
                onClick={() => {
                  removeFromData(clickindex, "approve");
                }}
                variant="success"
              >
                &#10004;
              </SlButton>
              <SlButton
                className="w-16 py-1"
                title="Block"
                disabled={data.length > 0 ? false : true}
                onClick={() => {
                  handleBlockImageDownload(campPreview['img'],campPreview['hdl'] )
                  removeFromData(clickindex, "block");
                }}
                variant="danger"
              >
                &#10008;
              </SlButton>
            </div>
          </div>
          <div className="w-3/12 m-auto">
            <div className="font-medium text-lg ">
              <>
                {`Advertiser:  ${campPreview?.adv}`}{" "}
                <SlIcon
                  name="files"
                  library="lucide"
                  onClick={handleClickhdl}
                  className="hover:cursor-pointer"
                  title="Copy Title"
                ></SlIcon>
              </>
            </div>
            <div className="font-medium text-lg ">
              {`Source:  ${
                campPreview?.adt_cls.includes("facebook")
                  ? "Facebook"
                  : "Google"
              }`}
            </div>
            <div className="font-medium text-lg ">
              {`Impressions: ${
                campPreview?.count === null ? 1 : campPreview?.count
              }`}
            </div>
          </div>
        </div>
      </SlDrawer>
      <div className="overflow-x-auto">
        <ScrollContainer>
          <table className="table table-bordered table-hover">
            <thead>
              <tr>
                <th>
                  <div className="flex gap-2">
                    <input
                      type="checkbox"
                      checked={
                        data.length > 0
                          ? selectedRows.length === data.length
                          : false
                      }
                      onChange={handleCheckAll}
                    />
                    {selectedRows.length > 0 ? (
                      <div className="flex justify-end">
                        <SlButton
                          variant="success"
                          size="small"
                          onclick={() => {
                            handleApproveMulti();
                          }}
                        >
                          Approve
                        </SlButton>
                      </div>
                    ) : null}
                  </div>
                </th>
                <th>Title</th>
                <th>Description</th>
                <th>Source</th>
                <th>Advertiser</th>
                <th>Impressions</th>
              </tr>
            </thead>
            {data?.length && !loader ? (
              <tbody>
                {data.map((item, index) => {
                  return (
                    <tr
                      key={index}
                      className="hover:cursor-pointer"
                      onClick={(e) => {
                        if (e.target.tagName.toLowerCase() !== "input") {
                          handleShowPreview();
                          setClickIndex(index);
                        }
                      }}
                    >
                      <td>
                        <input
                          type="checkbox"
                          checked={selectedRows.includes(item._id)}
                          onChange={() => {
                            handleCheckboxChange(item._id);
                          }}
                        />
                      </td>
                      <td>{item.hdl || "-"}</td>
                      <td>{item.bdy?.replace('/$', '$') || "-"}</td>
                      <td>
                        {item.adt_cls?.includes("facebook")
                          ? "Facebook"
                          : "Google"}
                      </td>
                      <td>{item.adv || "-"}</td>
                      <td>{item.count === null ? 1 : item.count}</td>
                    </tr>
                  );
                })}
              </tbody>
            ) : !data?.length && !loader ? (
              <NoDataFound colspan="8" />
            ) : (
              <TableLoader colspan="8" />
            )}
          </table>
        </ScrollContainer>
      </div>
      <div className="flex justify-end">
        {data?.length &&
        totalRecords > 0 &&
        currentPage <= Math.ceil(totalRecords / config.PER_PAGE) ? (
          <Paginator
            pageCount={Math.ceil(totalRecords / config.PER_PAGE)}
            handlePageClick={handlePageClick}
            forcePage={currentPage - 1}
          />
        ) : null}
      </div>
    </>
  );
}

export default Queued;
